import { gql } from "../__generated__";

export const GetObjectMaterials = gql(`
  query GetObjectMaterials($take: Int, $where: ObjektEigenschaftMaterialWhereInput) {
    items: objektEigenschaftMaterials(take: $take, where: $where) {
      id
      name
    }
  }
`);
